// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MapController from "./map_controller"
application.register("map", MapController)

import AutoFillController from "./auto_fill_controller"
application.register("auto_fill", AutoFillController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import IconsController from "./icons_controller"
application.register("icons", IconsController)
